import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useGetNotificationsQuery } from '@/app/api';
import { Notification } from './notification';
import { NotificationSidebar } from './notification-sidebar';

export const NotificationCenter = () => {
  const { pathname } = useLocation();
  const isHomePage = pathname === '/';

  const [open, setOpen] = useState(false);

  const {
    data: notifications,
    isLoading,
    isFetching,
  } = useGetNotificationsQuery(undefined, {
    pollingInterval: 3 * 60 * 1000,
    skip: isHomePage,
  });

  if (isHomePage) return null;

  return (
    <>
      <Notification
        onClick={() => setOpen(true)}
        count={notifications?.totalUnviewedNotifications}
        isLoading={isLoading || isFetching}
      />
      <NotificationSidebar
        open={open}
        onClose={() => setOpen(false)}
        notifications={notifications}
      />
    </>
  );
};
